<template>
  <SideBar
    :visible="isComplementarySidebarOpen"
    :title="$t('Build Your Perfect Bundle')"
    data-testid="complementaryProducts"
    @close="closeSidebar()"
  >
    <ComplementaryProductsInner />
    <template #content-bottom>
      <CartSidebarButtons
        :primary-button-text="$t('To the checkout')"
        :total-price="totalPrice"
        :price-label="$t('Package price:')"
        @primary-button-click="handlePrimaryButton"
      />
    </template>
  </SideBar>
</template>

<script lang="ts">

export default defineComponent({
  name: 'ComplementaryProductsSidebar',

  setup() {

    const { isComplementarySidebarOpen } = useUiState();
    const { closeComplementarySidebar, handleGoToCheckout } = useCartSidebars();
    const { totalPrice } = useComplementaryProductsTotalPrice();

    const closeSidebar = (shouldOpenCartSidebar: boolean = true) => {

      closeComplementarySidebar(shouldOpenCartSidebar);
    
    };

    const handlePrimaryButton = () => {

      handleGoToCheckout();
      closeSidebar(false);
    
    };

    return {
      totalPrice,
      isComplementarySidebarOpen,
      closeSidebar,
      handlePrimaryButton,
    };
  
  },
});

</script>
